module.exports = __webpack_public_path__ + "static/pemalex_logo_clientes_soleagua-b0454670be9f070bdfcf5598ed76f555.png";